<template>
  <el-dialog title='上传课程图片'
             :visible.sync="visible"
             width="75%"
             :append-to-body="true"
             @open="handleOpen"
             @before-close="handleClose">
    <el-row>
      <el-form :model="form" ref="form" label-width="125px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传图片" prop="attachList">
              <el-upload action="/sysAttach/uploadTempAttach/LESSON_PHOTO"
                         list-type="text" :accept="attachAcceptType"
                         :on-error="attachHandleError" :on-success="attachHandleSuccess"
                         :on-remove="attachHandleRemove" :on-preview="attachHandlePreview"
                         :before-upload="attachBeforeUpload" :before-remove="attachBeforeRemove"
                         :on-exceed="attachHandleExceedOne" :file-list="attachList" :limit="1"
                         :show-file-list=true multiple style="width: 500px">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red"> 上传文件大小不超过10MB，最多上传1个附件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="float: right; right: -10px;padding-bottom: 10px;">
        <el-button type="primary" @click="submit" size="medium">确定</el-button>
        <el-button @click="handleClose" size="medium">取消</el-button>
      </div>
    </el-row>
  </el-dialog>
</template>

<script>
import {uploadLessonBasePhoto } from "@/api/core/lessonBase";
import {commonAttachMixin} from "../../../../utils/commonAttachMixin";

export default {
  name: "lessonBaseUploadPhotoForm",
  mixins: [commonAttachMixin],
  props:['selRow'],
  data() {
    return {
      form : {
        lessonType:0
      },
      attachList:[],
      workTypeList:[],
      hospitalList:[],
      visible: false,
      attachAcceptType: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG',
    }
  },
  methods:{
    async handleOpen() {
      this.attachList = []
      this.form = {...this.selRow};
      if (this.form.id) {
        this.attachList = await this.findAttachListByDataId(this.form.id, 'LESSON_PHOTO')
      }
    },
    handleClose() {
      this.attachList = []
      this.form = {}
      this.visible = false
      this.$emit('refreshList');
    },
    submit() {
      uploadLessonBasePhoto(this.form).then(res =>{
        if (res.status == 200) {
          this.handleClose()
          this.$message({
            type: "success",
            message: '添加成功'
          });
          this.$emit('refreshList')
        }
      })
    },
    attachHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1个附件`)
    },
  }
}
</script>

<style scoped>

</style>